var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Voice Play"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 851",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#5790DF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"google-play\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.5201 41.5851L50.9609 45.9939L57.4957 42.2194C58.3696 41.7824 58.9292 40.897 58.9488 39.9201C58.9135 38.9753 58.3571 38.128 57.5041 37.7201C56.9613 37.4268 52.3068 34.7262 50.5603 33.7096L50.5553 33.7062L29.4004 21.4926C28.5356 20.9453 27.4431 20.906 26.5413 21.3898C26.4552 21.4483 26.3729 21.5122 26.2949 21.5811L46.5201 41.5851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.5034 37.7197C56.9954 37.4454 52.916 35.0794 50.9592 33.9415L46.4768 38.3915L26.2002 58.5076C26.283 58.5831 26.3714 58.6523 26.4646 58.7146C26.8252 58.9211 27.234 59.0287 27.6497 59.0264C28.1541 59.0201 28.6482 58.8818 29.0826 58.6252C29.7535 58.2358 50.5545 46.228 50.5545 46.228L57.4949 42.2192C58.3688 41.7822 58.9284 40.8967 58.948 39.9198C58.9127 38.975 58.3564 38.1277 57.5034 37.7197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.8849 39.9698L26.2958 21.5841C25.6304 22.0991 25.2306 22.8914 25.2647 23.7449V56.5183C25.2424 57.2992 25.604 58.0222 26.2019 58.5051L44.8849 39.9698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.5019 37.7197C56.2171 37.0279 51.6844 34.3642 50.9577 33.9415L46.4754 38.3915L44.8848 39.9694L46.518 41.5848L50.9588 45.9937L57.4935 42.2192C58.3674 41.7822 58.927 40.8967 58.9467 39.9198C58.9114 38.975 58.355 38.1276 57.5019 37.7197Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.e282c883a6d1a3083ef512d72f76effb.svg";
export { ForwardRef as ReactComponent };